import React, { FC } from 'react';
import { useSelector } from 'react-redux';

// Shared UI Library Components
import { CustomIcon, CustomTooltip, EIconName } from '@ppmcore/seven-ppm-core-shared-components-react';

// Styles
import './total-info.scss';

// Store entities
import { getDashboardState } from '../../../../store/dashboard/dashboard.selectors';
import { getCurrencyState } from '../../../../store/currency/currency.selectors';

type TTotalInfoProps = {};

export const TotalInfo: FC<TTotalInfoProps> = (
  {}: TTotalInfoProps
): JSX.Element => {
  const { totals } = useSelector(getDashboardState);
  const { currentCurrency } = useSelector(getCurrencyState);

  return (
    <div className="total-info">
      <div className="total-info--item">
        <div className="item-value">
          { totals?.total_consultations ?? '0' }
        </div>
        <div className="item-title">
          Total Consultations
          <CustomTooltip title={ 'This metric shows the total number of all completed consultations' }>
            <CustomIcon name={ EIconName.Info } size={ 'size-md' }/>
          </CustomTooltip>
        </div>
      </div>
      <div className="total-info--item">
        <div className="item-value">
          { currentCurrency?.symbol ?? '' }{ totals?.total_service_revenue ?? '0' }
        </div>
        <div className="item-title">
          Total Service Revenue
          <CustomTooltip title={ 'This metric shows the total revenue, excluding refunds for unfulfilled services' }>
            <CustomIcon name={ EIconName.Info } size={ 'size-md' }/>
          </CustomTooltip>
        </div>
      </div>
      <div className="total-info--item">
        <div className="item-value">
          { totals?.total_counsellors ?? '0' }
        </div>
        <div className="item-title">
          Total Consultants
          <CustomTooltip title={ 'This metric shows the current number of active Consultants' }>
            <CustomIcon name={ EIconName.Info } size={ 'size-md' }/>
          </CustomTooltip>
        </div>
      </div>
    </div>
  );
};
